import { useTranslation } from "react-i18next";

export const UpsChatting = () => {
    const { t } = useTranslation();
    return (
        <div className="grid-2-col margin-vertical-2 margin-horizontal-1">
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-chat-color">
                    <span className="font-size-2-half icon--ri chat-3-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Private Chats')}</p>
                <small className="text-align-center">{t('1:1 Messaging wie auf Whatsapp')}</small>
            </div>
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-image-color">
                    <span className="font-size-2-half icon--ri image-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Persönliche Botschaften')}</p>
                <small className="text-align-center">{t('Videos & Fotos nur für dich!')}</small>
            </div>
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-notification-color">
                    <span className="font-size-2-half icon--ri send-plane-fill"></span>
                </div>
                <p className="reset-margin text-align-center">{t('10 Gratis Nachrichten')}</p>
                <small className="text-align-center">{t('Für deine gratis Anmeldung')}</small>
            </div>
            <div className="flex-align-center flex-direction-column">
                <div className="margin-bottom-1 icon-background icon-lock-color">
                    <span className="font-size-2-half icon--ri ghost-line"></span>
                </div>
                <p className="reset-margin text-align-center">{t('Kein Ghosting')}</p>
                <small className="text-align-center">{t('Das Model schreibt dir zurück!')}</small>
            </div>
        </div>
    )
}